import type { FC } from 'react'

import { Navigate } from 'react-router-dom'


import { paths } from 'setup/PageRouter'

import type { AuthenticateUserProps } from 'setup/PageRouter/PageRouter'

const withAuth =
    <T extends object>(WrappedComponent: React.ComponentType<T>): FC<T & AuthenticateUserProps> =>
        (props) => {
            const { accessToken } = props

            const notLoggedIn = accessToken == null

            // skip ไม่ Call api เมมื่ออยู่ในหน้า login
            // const skip = notLoggedIn || window.location.pathname === paths.signIn

            if (notLoggedIn) {
                return <Navigate to={paths.signIn} />
            }

            return <WrappedComponent {...props} />
        }

export default withAuth
